import { MenuItem, Menu } from "@mui/material";
import { useState } from "react";
import { Button } from "react-bootstrap";

interface DropdownProps {
  id: string;
  title: string;
  onSelect: (eventKey: any) => void;
  options: { [key: string]: any };
}

export function DropdownButton({
  id,
  title,
  onSelect,
  options,
}: DropdownProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (selection: any) => {
    onSelect(selection);
    handleClose();
  };
  const menuItems = Object.keys(options).map((k: string) => {
    return (
      <MenuItem onClick={() => handleSelect(options[k])} key={k}>
        {k}
      </MenuItem>
    );
  });
  return (
    <>
      <Button
        id={id}
        aria-controls={open ? "dropdown-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
      >
        {title}
      </Button>
      <Menu
        id="dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {menuItems}
      </Menu>
    </>
  );
}
